/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React, { useState, useMemo, Suspense } from 'react';
import { View, StyleSheet, Text, Platform } from 'react-native';
import * as authActions from '~store/user/actions/auth';
import { notifyMe } from '~store/product-detail/thunks';
import { useDispatch, useSelector } from 'react-redux';
const Button = React.lazy(() => import('@web-components/form/Button'));
const Input = React.lazy(() => import('@web-components/form/Input'));
import InputPassword from '@web-components/form/input-extends/InputPassword';
import {
  formLabel,
  formGroup,
  formWrapper,
  formLabelError,
} from '~assets/styles/formStyles';
import ErrorCodes from '~global/ErrorCodes';
import Toast from 'react-native-toast-message';
import { SOC } from '~global/constants';
import WithLocalSvg from '@web-components/common/WithLocalSvg';
import {
  specialCharacterValidation,
  getAsyncData,
  removeAsyncData,
} from '~global/helpers';
import { CommonActions } from '@react-navigation/native';

const notifyKey = '@storage_notify';
const LoginScreen = (props) => {
  const { $size } = global;
  const dispatch = useDispatch();
  const loginData = useSelector((state) => state.modal.login.data);
  const autoRedirect = useSelector((state) => state.auth.autoRedirect);
  // eslint-disable-next-line no-unused-vars
  const [errorLabelStyle, setErrorLabelStyle] = useState({});
  const [hasError, setHasError] = useState({});
  const [hasErrorUserName, setHasErrorUserName] = useState(false);
  const [processing, setProcessing] = useState(false);
  const platform = SOC[Platform.OS];
  const [payload, setPayload] = useState({
    email: '',
    password: '',
    source: platform,
  });

  const setPayloadHandler = (data) => {
    setPayload({
      ...payload,
      ...data,
    });
    setHasError({});
    if (!data.password) {
      if (specialCharacterValidation.test(data?.email) || data.email === '') {
        setHasErrorUserName(true);
      } else {
        setHasErrorUserName(false);
      }
    }
  };

  const setPasswordHandler = (data) => {
    setPayload({
      ...payload,
      ...data,
    });
    setHasError({});
  };

  const getErrorStylesHandler = (stylesError) => {
    verifiedErrorForm(payload);
    setErrorLabelStyle(stylesError.labelStyle);
  };

  const verifiedErrorForm = (payload) => {
    setHasError(
      global.$validate(payload, {
        email: {
          presence: { allowEmpty: false },
        },

        password: {
          presence: { allowEmpty: false },
        },
      }),
    );
  };
  const handleLoginSucceed = async () => {
    if (!global.isNative) {
      const isAutoRedirect = $size(autoRedirect);
      dispatch({
        type: 'MODAL/HIDE',
        modalName: 'login',
        data: { handlerAfterLogin: loginData?.handlerAfterLogin },
      });
      if (isAutoRedirect) {
        props.navigation.dispatch((state) => {
          const routes = [...state.routes].filter(
            (route) => route.name !== 'LoginControlScreen',
          );
          return CommonActions.reset({
            ...state,
            routes,
            index: routes.length - 1,
          });
        });
        props.navigation.navigate(autoRedirect.screen, autoRedirect.params);
      } else {
        if (loginData?.to) {
          try {
            props.navigation.reset({
              index: 0,
              routes: [{ name: loginData?.to }],
            });
          } catch (error) {
            props.navigation.navigate(loginData?.to);
          }
        }
        // show notify modal
        try {
          const userData = await getAsyncData('userData');
          const notifyData = await getAsyncData(notifyKey);
          if (notifyData) {
            notifyData.email = userData?.user?.email;
            notifyData.user = {
              email: userData?.user?.email,
              id: userData?.userId,
              name: userData?.user?.name,
            };
          }

          if (userData && notifyData) {
            await dispatch(notifyMe(notifyData))
              .unwrap()
              .then((response) => {
                if (response.success) {
                  dispatch({
                    type: 'MODAL/SHOW',
                    modalName: 'notifyMeSuccess',
                    data: { id: notifyData.product_id },
                  });
                } else {
                  Toast.show({
                    text1: 'Silakan coba lagi dalam beberapa saat.',
                    type: 'error',
                  });
                }
                removeAsyncData(notifyKey);
              });
          }
        } catch (err) {
          console.log(err);
        }
      }
    } else {
      props.navigation.goBack();
    }
    if (global.isNative) {
      Toast.show({ text1: 'Login succeed!' });
    } else {
      Toast.show({ text1: 'Hi, welcome to Lilla!' });
    }
  };

  const loginHandler = async () => {
    try {
      setProcessing(true);
      verifiedErrorForm(payload);
      if (hasError && Object.keys(hasError)?.length) {
        setProcessing(false);
        return;
      }
      const res = await dispatch(authActions.userLogin(payload));
      if (res?.data?.errorCode) {
        const errorType =
          res.errorCode === 'INCORRECT_PASSWORD' ||
          /login_attempt|ACCOUNT_LOCKED|USER_ALREADY_REMOVED/gi.test(
            res.errorCode,
          )
            ? 'password'
            : 'email';
        setHasError({ [errorType]: ErrorCodes[res.errorCode] });
        setProcessing(false);
      } else {
        if (!global.isNative) {
          setProcessing(false);
          const userID = res && Object.keys(res).length ? res.my_sql_id : '';
          const userIDMongo = res && Object.keys(res).length ? res._id : '';
          const userEmail = res && Object.keys(res).length ? res.email : '';
          // hashedEmail = res && Object.keys(res).length ? md5(res.email) : '';
          const userName = res && Object.keys(res).length ? res.user_name : '';
          const userFirstname =
            res && Object.keys(res).length ? res.first_name : '';
          const userLastname =
            res && Object.keys(res).length ? res.last_name : '';
          const userBirth =
            res && Object.keys(res).length && 'date_of_birth' in res
              ? res.date_of_birth
              : '';
          const userGender =
            res && Object.keys(res).length && 'gender' in res ? res.gender : '';
          const userPhone =
            res && Object.keys(res).length && 'phone_no' in res
              ? res.phone_no
              : '';
          const userCountry =
            res && Object.keys(res).length && 'country' in res
              ? res.country.name
              : '';

          window.dataLayer.push({
            event: 'loggedIn',
            user_id: userID,
            user_id_mongo: userIDMongo,
            user_data: {
              userID,
              userIDMongo,
              userEmail,
              // hashedEmail,
              userName,
              userFirstname,
              userLastname,
              userBirth,
              userGender,
              userPhone,
              userCountry,
            },
          });
          handleLoginSucceed();
          return;
        }

        setProcessing(false);

        Toast.show({
          text1: 'Your data is saved. Welcome!',
          autoHide: true,
          visibilityTime: 100,
          onHide: handleLoginSucceed,
        });
        if (!res?.is_lilla_member) {
          dispatch({ type: 'MODAL/SHOW', modalName: 'consent' });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleUserNameLaberError = useMemo(() => {
    if (hasError?.email || hasErrorUserName) {
      return formLabelError;
    } else {
      return {};
    }
  }, [hasError, hasErrorUserName]);

  return (
    <Suspense fallback={<></>}>
      <View style={formWrapper}>
        <View style={formGroup}>
          <Input
            label={
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Text style={[formLabel, handleUserNameLaberError]}>
                  Username/Email{' '}
                </Text>
                <WithLocalSvg
                  width={45}
                  height={46}
                  style={{ marginTop: -6, marginLeft: 4 }}
                  asset={require('~assets/img/common/logo-login-soco.svg')}
                />
              </View>
            }
            placeholder=""
            onChangeText={(email) => setPayloadHandler({ email })}
            hasError={hasError && hasError.email}
            validate={{
              presence: {
                allowEmpty: false,
                message: 'Email/Username belum diisi',
              },
            }}
            getErrorStyles={getErrorStylesHandler}
          />
          {Object.keys(handleUserNameLaberError).length === 0 && (
            <View style={{ flexDirection: 'row' }}>
              <Text style={[formLabel, styles.textSocoAccountLabel]}>
                You can use your Soco account here
              </Text>
            </View>
          )}
        </View>
      </View>

      <View style={[formWrapper, styles.formWrapperLast]}>
        <View style={formGroup}>
          <InputPassword
            label={
              <Text
                style={[
                  formLabel,
                  hasError && hasError.password ? formLabelError : {},
                ]}>
                Password
              </Text>
            }
            placeholder=""
            onChangeText={(password) => setPasswordHandler({ password })}
            hasError={hasError && hasError.password}
            inputContainerStyle={{ color: 'red' }}
            value={payload.password}
            validate={{
              presence: {
                allowEmpty: false,
                message: 'Password belum diisi',
              },
            }}
            getErrorStyles={getErrorStylesHandler}
          />
        </View>
      </View>

      <View style={[formGroup, { marginBottom: 24 }]}>
        <Text
          style={styles.textForgotPassword}
          onPress={() => {
            dispatch({ type: 'MODAL/HIDE', modalName: 'login' });
            props.navigation.navigate('ForgotPasswordScreen', { tab: '' });
          }}>
          Forgot Password?
        </Text>
      </View>

      <Button
        onPress={loginHandler}
        title="Login"
        disabled={
          !(payload.email.length && payload.password.length) || processing
        }
        loading={processing}
      />

      {/* {!global.isNative && (
        <>
          <View style={styles.divider}>
            <View style={styles.dividerLine} />
            <Text style={styles.subDivider}>or</Text>
            <View style={styles.dividerLine} />
          </View>
          <LoginButtonFacebook
            navigation={props.navigation}
            title="Login with Facebook"
          />
        </>
      )} */}
    </Suspense>
  );
};

const styles = StyleSheet.create({
  // divider: {
  //   marginVertical: 20,
  //   flexDirection: 'row',
  // },
  // dividerLine: {
  //   backgroundColor: '#8b7fbf',
  //   height: 1,
  //   flex: 1,
  //   alignSelf: 'center',
  // },
  // subDivider: {
  //   alignSelf: 'center',
  //   paddingHorizontal: 10,
  //   fontSize: 12,
  // },
  textForgotPassword: {
    color: '#8B7FBF',
    fontSize: 13,
    lineHeight: 18,
    fontFamily: 'satoshi-bold',
    textAlign: 'right',
  },
  formWrapperLast: {
    marginBottom: 12,
  },
  textSocoAccountLabel: { marginTop: -4, color: '#D8D8D8' },
});

export default LoginScreen;
